<vl-form-grid mod-stacked>
    <vl-column v-if="isCitizen">
        <vl-alert :closable="false">
            <vl-typography>
                <div><b>Let op!</b> U staat op het punt om af te rekenen <b>als particulier</b>. U zal een factuur op uw
                    naam krijgen. Als particulier kan u <b>geen</b> facturen op naam van een organisatie krijgen.</div>
                <div><b>Heeft u een factuur nodig op naam van een organisatie?</b> Meld u dan aan voor de organisatie in
                    kwestie.</div>
            </vl-typography>
        </vl-alert>
    </vl-column>
    <vl-column>
        <kl-contact-card :title="title" :subtitle="subtitle" />
    </vl-column>
    <template v-if="vatNumberRequired">
        <vl-column width-s="8" width-m="6" width-l="4">
            <kl-field-validation-wrapper-yup for="vatNumber" :field="fields.vatNumber" #default="{hasErrors}"
                mod-required>
                <vl-input-field name="KBO-nummer" id="vatNumber" v-model="vatNumber" :mod-error="hasErrors" mod-block />
            </kl-field-validation-wrapper-yup>
        </vl-column>
        <vl-column width-s="4" width-m="6" width-l="8" v-vl-visibility:hide.s />
    </template>
    <vl-column>
        <kl-address-form v-model="address" :form-path="fields.address.path" />
    </vl-column>
    <vl-column width-s="8" width-m="6" width-l="7">
        <kl-field-validation-wrapper-yup for="email-address" :field="fields.emailAddress" #default="{hasErrors}"
            :annotation="emailAddressAnnotation" mod-required>
            <vl-input-field name="e-mailadres" id="email-address" v-model="emailAddress" autocomplete="on"
                placeholder="E-mail" :mod-error="hasErrors" mod-block />
        </kl-field-validation-wrapper-yup>
    </vl-column>
    <vl-column width-s="8" width-m="6" width-l="7" v-if="showOwnReference">
        <kl-field-validation-wrapper-yup :field="fields.ownReference" for="ownReference" #default="{hasErrors}"
            :annotation="ownReferenceAnnotation">
            <vl-input-field name="ownReference" id="ownReference" v-model="ownReference" :mod-error="hasErrors"
                mod-block />
        </kl-field-validation-wrapper-yup>
    </vl-column>
    <vl-column width-s="4" width-m="6" width-l="8" v-vl-visibility:hide.s />
</vl-form-grid>
